export default function Skeleton({ className = "", style, variant = "line" }) {
  return (
    <div
      className={`skeleton skeleton-${variant} ${className}`.trim()}
      style={style}
      aria-hidden="true"
    />
  );
}
